export const NWD_VERSION = 'network-dashboard@v10.4.4';
